import React from 'react';
import { Layout } from '../components/common';

const DashboardDemo = () => {
  return (
    <Layout activeNav="dashboard" onNavChange={() => {}}>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Dashboard</h1>
        <p className="text-gray-600">Welcome to WMS Portal.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="text-4xl font-bold text-primary mb-2">1,234</div>
          <p className="text-gray-600">Total Products</p>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="text-4xl font-bold text-success mb-2">856</div>
          <p className="text-gray-600">In Stock</p>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="text-4xl font-bold text-warning mb-2">142</div>
          <p className="text-gray-600">Low Stock</p>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="text-4xl font-bold text-danger mb-2">45</div>
          <p className="text-gray-600">Pending Orders</p>
        </div>
      </div>
    </Layout>
  );
};

export default DashboardDemo;
